<template>
  <footer class="main-footer">
    <div class="footer-container">
      <!-- Colonne 1 : Logo + slogan -->
      <div class="footer-column">
        <h2>{{ storeName || "DinarZ" }}</h2>
        <p>{{ storeTitle || "opportunité et valeurs" }}</p>
        <p class="small-text">🚚 Livraison partout en Algérie</p>
      </div>

      <!-- Colonne 2 : Liens -->
      <div class="footer-column">
        <h3>Pages</h3>
        <ul>
          <li><a href="/">Accueil</a></li>
          <li><a href="/produits">Produits</a></li>
          <li><a href="/categories">Catégories</a></li>
        </ul>
      </div>

      <!-- Colonne 3 : Contact Dynamique -->
      <div class="footer-column">
        <h3>Contact</h3>
        <p v-if="storePhone">📞 {{ storePhone }}</p>
        <p v-if="storeEmail">✉️ {{ storeEmail }}</p>

        <!-- Affichage dynamique des réseaux sociaux -->
        <div v-if="socialLinks">
          <template v-if="socialLinks.whatsapp && socialLinks.whatsapp.length">
            <p v-for="link in socialLinks.whatsapp" :key="link">
              <a :href="link" target="_blank">WhatsApp</a>
            </p>
          </template>
          <template
            v-if="socialLinks.instagram && socialLinks.instagram.length"
          >
            <p v-for="link in socialLinks.instagram" :key="link">
              <a :href="link" target="_blank">Instagram</a>
            </p>
          </template>
          <template v-if="socialLinks.facebook && socialLinks.facebook.length">
            <p v-for="link in socialLinks.facebook" :key="link">
              <a :href="link" target="_blank">Facebook</a>
            </p>
          </template>
          <template v-if="socialLinks.tiktok && socialLinks.tiktok.length">
            <p v-for="link in socialLinks.tiktok" :key="link">
              <a :href="link" target="_blank">TikTok</a>
            </p>
          </template>
          <template v-if="socialLinks.snapchat && socialLinks.snapchat.length">
            <p v-for="link in socialLinks.snapchat" :key="link">
              <a :href="link" target="_blank">Snapchat</a>
            </p>
          </template>
          <template v-if="socialLinks.youtube && socialLinks.youtube.length">
            <p v-for="link in socialLinks.youtube" :key="link">
              <a :href="link" target="_blank">YouTube</a>
            </p>
          </template>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      &copy; {{ new Date().getFullYear() }} - Tous Droits Réservés |
      {{ storeName || "DinarZ" }}
    </div>
  </footer>
</template>

<script setup>
import { computed } from "vue";
import { useStoreConfig } from "../services/storeService";

const { storeConfig } = useStoreConfig();

const storeName = computed(() => storeConfig.value?.name || "");
const storeTitle = computed(() => storeConfig.value?.title || "");
const storeEmail = computed(() => storeConfig.value?.email_contact || "");
const storePhone = computed(() => storeConfig.value?.phone || "0670-72-67-91");

const socialLinks = computed(() => {
  if (storeConfig.value && storeConfig.value.social_links) {
    if (typeof storeConfig.value.social_links === "string") {
      try {
        return JSON.parse(storeConfig.value.social_links);
      } catch (e) {
        return {};
      }
    }
    return storeConfig.value.social_links;
  }
  return {};
});
</script>

<style scoped>
.main-footer {
  background: var(--dark, #1e293b);
  color: #f8fafc;
  padding: 60px 20px 100px;
  font-family: inherit;
}

.footer-container {
  max-width: 1200px;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 40px;
  text-align: left;
}

.footer-column {
  flex: 1 1 250px;
  min-width: 200px;
}

.footer-column h2,
.footer-column h3 {
  margin-bottom: 20px;
  color: white;
  font-weight: 600;
  font-size: 1.1rem;
}

.footer-column p,
.footer-column li {
  margin: 10px 0;
  color: #cbd5e1;
}

.footer-column ul {
  list-style: none;
  padding: 0;
}

.footer-column a {
  color: #ccc;
  text-decoration: none;
}

.footer-column a:hover {
  text-decoration: underline;
  color: #fff;
}

.footer-column p {
  display: flex;
  align-items: center;
  gap: 10px;
}

.footer-column svg {
  width: 20px;
  height: 20px;
  opacity: 0.8;
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 50px;
  padding-top: 25px;
  text-align: center;
  font-size: 0.85em;
  color: #94a3b8;
}

.small-text {
  font-size: 0.85em;
  color: #bbb;
}
</style>
